export default "__VITE_ASSET__BNNj5MR4__"